<template>
  <div></div>
</template>

<script>
export default {
  name: "AccountsPage",
  props: {},
};
</script>